var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea55a"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea55a"] = parcelRequire;
}
parcelRequire.register("50i7i", function(module, exports) {
/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */ (function() {
    function aa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function ba(a, b, c) {
        if (!a) throw Error();
        if (2 < arguments.length) {
            var d = Array.prototype.slice.call(arguments, 2);
            return function() {
                var c = Array.prototype.slice.call(arguments);
                Array.prototype.unshift.apply(c, d);
                return a.apply(b, c);
            };
        }
        return function() {
            return a.apply(b, arguments);
        };
    }
    function p(a, b, c) {
        p = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? aa : ba;
        return p.apply(null, arguments);
    }
    var q = Date.now || function() {
        return +new Date;
    };
    function ca(a, b) {
        this.a = a;
        this.o = b || a;
        this.c = this.o.document;
    }
    var da = !!window.FontFace;
    function t(a, b, c, d) {
        b = a.c.createElement(b);
        if (c) for(var e in c)c.hasOwnProperty(e) && ("style" == e ? b.style.cssText = c[e] : b.setAttribute(e, c[e]));
        d && b.appendChild(a.c.createTextNode(d));
        return b;
    }
    function u(a, b, c) {
        a = a.c.getElementsByTagName(b)[0];
        a || (a = document.documentElement);
        a.insertBefore(c, a.lastChild);
    }
    function v(a) {
        a.parentNode && a.parentNode.removeChild(a);
    }
    function w(a, b, c) {
        b = b || [];
        c = c || [];
        for(var d = a.className.split(/\s+/), e = 0; e < b.length; e += 1){
            for(var f = !1, g = 0; g < d.length; g += 1)if (b[e] === d[g]) {
                f = !0;
                break;
            }
            f || d.push(b[e]);
        }
        b = [];
        for(e = 0; e < d.length; e += 1){
            f = !1;
            for(g = 0; g < c.length; g += 1)if (d[e] === c[g]) {
                f = !0;
                break;
            }
            f || b.push(d[e]);
        }
        a.className = b.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
    }
    function y(a, b) {
        for(var c = a.className.split(/\s+/), d = 0, e = c.length; d < e; d++)if (c[d] == b) return !0;
        return !1;
    }
    function ea(a) {
        return a.o.location.hostname || a.a.location.hostname;
    }
    function z(a, b, c) {
        function d() {
            m && e && f && (m(g), m = null);
        }
        b = t(a, "link", {
            rel: "stylesheet",
            href: b,
            media: "all"
        });
        var e = !1, f = !0, g = null, m = c || null;
        da ? (b.onload = function() {
            e = !0;
            d();
        }, b.onerror = function() {
            e = !0;
            g = Error("Stylesheet failed to load");
            d();
        }) : setTimeout(function() {
            e = !0;
            d();
        }, 0);
        u(a, "head", b);
    }
    function A(a, b, c, d) {
        var e = a.c.getElementsByTagName("head")[0];
        if (e) {
            var f = t(a, "script", {
                src: b
            }), g = !1;
            f.onload = f.onreadystatechange = function() {
                g || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (g = !0, c && c(null), f.onload = f.onreadystatechange = null, "HEAD" == f.parentNode.tagName && e.removeChild(f));
            };
            e.appendChild(f);
            setTimeout(function() {
                g || (g = !0, c && c(Error("Script load timeout")));
            }, d || 5E3);
            return f;
        }
        return null;
    }
    function B() {
        this.a = 0;
        this.c = null;
    }
    function C(a) {
        a.a++;
        return function() {
            a.a--;
            D(a);
        };
    }
    function E(a, b) {
        a.c = b;
        D(a);
    }
    function D(a) {
        0 == a.a && a.c && (a.c(), a.c = null);
    }
    function F(a) {
        this.a = a || "-";
    }
    F.prototype.c = function(a) {
        for(var b = [], c = 0; c < arguments.length; c++)b.push(arguments[c].replace(/[\W_]+/g, "").toLowerCase());
        return b.join(this.a);
    };
    function G(a, b) {
        this.c = a;
        this.f = 4;
        this.a = "n";
        var c = (b || "n4").match(/^([nio])([1-9])$/i);
        c && (this.a = c[1], this.f = parseInt(c[2], 10));
    }
    function fa(a) {
        return H(a) + " " + (a.f + "00") + " 300px " + I(a.c);
    }
    function I(a) {
        var b = [];
        a = a.split(/,\s*/);
        for(var c = 0; c < a.length; c++){
            var d = a[c].replace(/['"]/g, "");
            -1 != d.indexOf(" ") || /^\d/.test(d) ? b.push("'" + d + "'") : b.push(d);
        }
        return b.join(",");
    }
    function J(a) {
        return a.a + a.f;
    }
    function H(a) {
        var b = "normal";
        "o" === a.a ? b = "oblique" : "i" === a.a && (b = "italic");
        return b;
    }
    function ga(a) {
        var b = 4, c = "n", d = null;
        a && ((d = a.match(/(normal|oblique|italic)/i)) && d[1] && (c = d[1].substr(0, 1).toLowerCase()), (d = a.match(/([1-9]00|normal|bold)/i)) && d[1] && (/bold/i.test(d[1]) ? b = 7 : /[1-9]00/.test(d[1]) && (b = parseInt(d[1].substr(0, 1), 10))));
        return c + b;
    }
    function ha(a, b) {
        this.c = a;
        this.f = a.o.document.documentElement;
        this.h = b;
        this.a = new F("-");
        this.j = !1 !== b.events;
        this.g = !1 !== b.classes;
    }
    function ia(a) {
        a.g && w(a.f, [
            a.a.c("wf", "loading")
        ]);
        K(a, "loading");
    }
    function L(a) {
        if (a.g) {
            var b = y(a.f, a.a.c("wf", "active")), c = [], d = [
                a.a.c("wf", "loading")
            ];
            b || c.push(a.a.c("wf", "inactive"));
            w(a.f, c, d);
        }
        K(a, "inactive");
    }
    function K(a, b, c) {
        if (a.j && a.h[b]) {
            if (c) a.h[b](c.c, J(c));
            else a.h[b]();
        }
    }
    function ja() {
        this.c = {};
    }
    function ka(a, b, c) {
        var d = [], e;
        for(e in b)if (b.hasOwnProperty(e)) {
            var f = a.c[e];
            f && d.push(f(b[e], c));
        }
        return d;
    }
    function M(a, b) {
        this.c = a;
        this.f = b;
        this.a = t(this.c, "span", {
            "aria-hidden": "true"
        }, this.f);
    }
    function N(a) {
        u(a.c, "body", a.a);
    }
    function O(a) {
        return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + I(a.c) + ";" + ("font-style:" + H(a) + ";font-weight:" + (a.f + "00") + ";");
    }
    function P(a, b, c, d, e, f) {
        this.g = a;
        this.j = b;
        this.a = d;
        this.c = c;
        this.f = e || 3E3;
        this.h = f || void 0;
    }
    P.prototype.start = function() {
        var a = this.c.o.document, b = this, c = q(), d = new Promise(function(d, e) {
            function f() {
                q() - c >= b.f ? e() : a.fonts.load(fa(b.a), b.h).then(function(a) {
                    1 <= a.length ? d() : setTimeout(f, 25);
                }, function() {
                    e();
                });
            }
            f();
        }), e = null, f = new Promise(function(a, d) {
            e = setTimeout(d, b.f);
        });
        Promise.race([
            f,
            d
        ]).then(function() {
            e && (clearTimeout(e), e = null);
            b.g(b.a);
        }, function() {
            b.j(b.a);
        });
    };
    function Q(a, b, c, d, e, f, g) {
        this.v = a;
        this.B = b;
        this.c = c;
        this.a = d;
        this.s = g || "BESbswy";
        this.f = {};
        this.w = e || 3E3;
        this.u = f || null;
        this.m = this.j = this.h = this.g = null;
        this.g = new M(this.c, this.s);
        this.h = new M(this.c, this.s);
        this.j = new M(this.c, this.s);
        this.m = new M(this.c, this.s);
        a = new G(this.a.c + ",serif", J(this.a));
        a = O(a);
        this.g.a.style.cssText = a;
        a = new G(this.a.c + ",sans-serif", J(this.a));
        a = O(a);
        this.h.a.style.cssText = a;
        a = new G("serif", J(this.a));
        a = O(a);
        this.j.a.style.cssText = a;
        a = new G("sans-serif", J(this.a));
        a = O(a);
        this.m.a.style.cssText = a;
        N(this.g);
        N(this.h);
        N(this.j);
        N(this.m);
    }
    var R = {
        D: "serif",
        C: "sans-serif"
    }, S = null;
    function T() {
        if (null === S) {
            var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
            S = !!a && (536 > parseInt(a[1], 10) || 536 === parseInt(a[1], 10) && 11 >= parseInt(a[2], 10));
        }
        return S;
    }
    Q.prototype.start = function() {
        this.f.serif = this.j.a.offsetWidth;
        this.f["sans-serif"] = this.m.a.offsetWidth;
        this.A = q();
        U(this);
    };
    function la(a, b, c) {
        for(var d in R)if (R.hasOwnProperty(d) && b === a.f[R[d]] && c === a.f[R[d]]) return !0;
        return !1;
    }
    function U(a) {
        var b = a.g.a.offsetWidth, c = a.h.a.offsetWidth, d;
        (d = b === a.f.serif && c === a.f["sans-serif"]) || (d = T() && la(a, b, c));
        d ? q() - a.A >= a.w ? T() && la(a, b, c) && (null === a.u || a.u.hasOwnProperty(a.a.c)) ? V(a, a.v) : V(a, a.B) : ma(a) : V(a, a.v);
    }
    function ma(a) {
        setTimeout(p(function() {
            U(this);
        }, a), 50);
    }
    function V(a, b) {
        setTimeout(p(function() {
            v(this.g.a);
            v(this.h.a);
            v(this.j.a);
            v(this.m.a);
            b(this.a);
        }, a), 0);
    }
    function W(a, b, c) {
        this.c = a;
        this.a = b;
        this.f = 0;
        this.m = this.j = !1;
        this.s = c;
    }
    var X = null;
    W.prototype.g = function(a) {
        var b = this.a;
        b.g && w(b.f, [
            b.a.c("wf", a.c, J(a).toString(), "active")
        ], [
            b.a.c("wf", a.c, J(a).toString(), "loading"),
            b.a.c("wf", a.c, J(a).toString(), "inactive")
        ]);
        K(b, "fontactive", a);
        this.m = !0;
        na(this);
    };
    W.prototype.h = function(a) {
        var b = this.a;
        if (b.g) {
            var c = y(b.f, b.a.c("wf", a.c, J(a).toString(), "active")), d = [], e = [
                b.a.c("wf", a.c, J(a).toString(), "loading")
            ];
            c || d.push(b.a.c("wf", a.c, J(a).toString(), "inactive"));
            w(b.f, d, e);
        }
        K(b, "fontinactive", a);
        na(this);
    };
    function na(a) {
        0 == --a.f && a.j && (a.m ? (a = a.a, a.g && w(a.f, [
            a.a.c("wf", "active")
        ], [
            a.a.c("wf", "loading"),
            a.a.c("wf", "inactive")
        ]), K(a, "active")) : L(a.a));
    }
    function oa(a) {
        this.j = a;
        this.a = new ja;
        this.h = 0;
        this.f = this.g = !0;
    }
    oa.prototype.load = function(a) {
        this.c = new ca(this.j, a.context || this.j);
        this.g = !1 !== a.events;
        this.f = !1 !== a.classes;
        pa(this, new ha(this.c, a), a);
    };
    function qa(a, b, c, d, e) {
        var f = 0 == --a.h;
        (a.f || a.g) && setTimeout(function() {
            var a = e || null, m = d || null || {};
            if (0 === c.length && f) L(b.a);
            else {
                b.f += c.length;
                f && (b.j = f);
                var h, l = [];
                for(h = 0; h < c.length; h++){
                    var k = c[h], n = m[k.c], r = b.a, x = k;
                    r.g && w(r.f, [
                        r.a.c("wf", x.c, J(x).toString(), "loading")
                    ]);
                    K(r, "fontloading", x);
                    r = null;
                    if (null === X) {
                        if (window.FontFace) {
                            var x = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), xa = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                            X = x ? 42 < parseInt(x[1], 10) : xa ? !1 : !0;
                        } else X = !1;
                    }
                    X ? r = new P(p(b.g, b), p(b.h, b), b.c, k, b.s, n) : r = new Q(p(b.g, b), p(b.h, b), b.c, k, b.s, a, n);
                    l.push(r);
                }
                for(h = 0; h < l.length; h++)l[h].start();
            }
        }, 0);
    }
    function pa(a, b, c) {
        var d = [], e = c.timeout;
        ia(b);
        var d = ka(a.a, c, a.c), f = new W(a.c, b, e);
        a.h = d.length;
        b = 0;
        for(c = d.length; b < c; b++)d[b].load(function(b, d, c) {
            qa(a, f, b, d, c);
        });
    }
    function ra(a, b) {
        this.c = a;
        this.a = b;
    }
    ra.prototype.load = function(a) {
        function b() {
            if (f["__mti_fntLst" + d]) {
                var c = f["__mti_fntLst" + d](), e = [], h;
                if (c) for(var l = 0; l < c.length; l++){
                    var k = c[l].fontfamily;
                    void 0 != c[l].fontStyle && void 0 != c[l].fontWeight ? (h = c[l].fontStyle + c[l].fontWeight, e.push(new G(k, h))) : e.push(new G(k));
                }
                a(e);
            } else setTimeout(function() {
                b();
            }, 50);
        }
        var c = this, d = c.a.projectId, e = c.a.version;
        if (d) {
            var f = c.c.o;
            A(this.c, (c.a.api || "https://fast.fonts.net/jsapi") + "/" + d + ".js" + (e ? "?v=" + e : ""), function(e) {
                e ? a([]) : (f["__MonotypeConfiguration__" + d] = function() {
                    return c.a;
                }, b());
            }).id = "__MonotypeAPIScript__" + d;
        } else a([]);
    };
    function sa(a, b) {
        this.c = a;
        this.a = b;
    }
    sa.prototype.load = function(a) {
        var b, c, d = this.a.urls || [], e = this.a.families || [], f = this.a.testStrings || {}, g = new B;
        b = 0;
        for(c = d.length; b < c; b++)z(this.c, d[b], C(g));
        var m = [];
        b = 0;
        for(c = e.length; b < c; b++)if (d = e[b].split(":"), d[1]) for(var h = d[1].split(","), l = 0; l < h.length; l += 1)m.push(new G(d[0], h[l]));
        else m.push(new G(d[0]));
        E(g, function() {
            a(m, f);
        });
    };
    function ta(a, b) {
        a ? this.c = a : this.c = ua;
        this.a = [];
        this.f = [];
        this.g = b || "";
    }
    var ua = "https://fonts.googleapis.com/css";
    function va(a, b) {
        for(var c = b.length, d = 0; d < c; d++){
            var e = b[d].split(":");
            3 == e.length && a.f.push(e.pop());
            var f = "";
            2 == e.length && "" != e[1] && (f = ":");
            a.a.push(e.join(f));
        }
    }
    function wa(a) {
        if (0 == a.a.length) throw Error("No fonts to load!");
        if (-1 != a.c.indexOf("kit=")) return a.c;
        for(var b = a.a.length, c = [], d = 0; d < b; d++)c.push(a.a[d].replace(/ /g, "+"));
        b = a.c + "?family=" + c.join("%7C");
        0 < a.f.length && (b += "&subset=" + a.f.join(","));
        0 < a.g.length && (b += "&text=" + encodeURIComponent(a.g));
        return b;
    }
    function ya(a) {
        this.f = a;
        this.a = [];
        this.c = {};
    }
    var za = {
        latin: "BESbswy",
        "latin-ext": "\xe7\xf6\xfcğş",
        cyrillic: "йяЖ",
        greek: "αβΣ",
        khmer: "កខគ",
        Hanuman: "កខគ"
    }, Aa = {
        thin: "1",
        extralight: "2",
        "extra-light": "2",
        ultralight: "2",
        "ultra-light": "2",
        light: "3",
        regular: "4",
        book: "4",
        medium: "5",
        "semi-bold": "6",
        semibold: "6",
        "demi-bold": "6",
        demibold: "6",
        bold: "7",
        "extra-bold": "8",
        extrabold: "8",
        "ultra-bold": "8",
        ultrabold: "8",
        black: "9",
        heavy: "9",
        l: "3",
        r: "4",
        b: "7"
    }, Ba = {
        i: "i",
        italic: "i",
        n: "n",
        normal: "n"
    }, Ca = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
    function Da(a) {
        for(var b = a.f.length, c = 0; c < b; c++){
            var d = a.f[c].split(":"), e = d[0].replace(/\+/g, " "), f = [
                "n4"
            ];
            if (2 <= d.length) {
                var g;
                var m = d[1];
                g = [];
                if (m) for(var m = m.split(","), h = m.length, l = 0; l < h; l++){
                    var k;
                    k = m[l];
                    if (k.match(/^[\w-]+$/)) {
                        var n = Ca.exec(k.toLowerCase());
                        if (null == n) k = "";
                        else {
                            k = n[2];
                            k = null == k || "" == k ? "n" : Ba[k];
                            n = n[1];
                            if (null == n || "" == n) n = "4";
                            else var r = Aa[n], n = r ? r : isNaN(n) ? "4" : n.substr(0, 1);
                            k = [
                                k,
                                n
                            ].join("");
                        }
                    } else k = "";
                    k && g.push(k);
                }
                0 < g.length && (f = g);
                3 == d.length && (d = d[2], g = [], d = d ? d.split(",") : g, 0 < d.length && (d = za[d[0]]) && (a.c[e] = d));
            }
            a.c[e] || (d = za[e]) && (a.c[e] = d);
            for(d = 0; d < f.length; d += 1)a.a.push(new G(e, f[d]));
        }
    }
    function Ea(a, b) {
        this.c = a;
        this.a = b;
    }
    var Fa = {
        Arimo: !0,
        Cousine: !0,
        Tinos: !0
    };
    Ea.prototype.load = function(a) {
        var b = new B, c = this.c, d = new ta(this.a.api, this.a.text), e = this.a.families;
        va(d, e);
        var f = new ya(e);
        Da(f);
        z(c, wa(d), C(b));
        E(b, function() {
            a(f.a, f.c, Fa);
        });
    };
    function Ga(a, b) {
        this.c = a;
        this.a = b;
    }
    Ga.prototype.load = function(a) {
        var b = this.a.id, c = this.c.o;
        b ? A(this.c, (this.a.api || "https://use.typekit.net") + "/" + b + ".js", function(b) {
            if (b) a([]);
            else if (c.Typekit && c.Typekit.config && c.Typekit.config.fn) {
                b = c.Typekit.config.fn;
                for(var e = [], f = 0; f < b.length; f += 2)for(var g = b[f], m = b[f + 1], h = 0; h < m.length; h++)e.push(new G(g, m[h]));
                try {
                    c.Typekit.load({
                        events: !1,
                        classes: !1,
                        async: !0
                    });
                } catch (l) {}
                a(e);
            }
        }, 2E3) : a([]);
    };
    function Ha(a, b) {
        this.c = a;
        this.f = b;
        this.a = [];
    }
    Ha.prototype.load = function(a) {
        var b = this.f.id, c = this.c.o, d = this;
        b ? (c.__webfontfontdeckmodule__ || (c.__webfontfontdeckmodule__ = {}), c.__webfontfontdeckmodule__[b] = function(b, c) {
            for(var g = 0, m = c.fonts.length; g < m; ++g){
                var h = c.fonts[g];
                d.a.push(new G(h.name, ga("font-weight:" + h.weight + ";font-style:" + h.style)));
            }
            a(d.a);
        }, A(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + ea(this.c) + "/" + b + ".js", function(b) {
            b && a([]);
        })) : a([]);
    };
    var Y = new oa(window);
    Y.a.c.custom = function(a, b) {
        return new sa(b, a);
    };
    Y.a.c.fontdeck = function(a, b) {
        return new Ha(b, a);
    };
    Y.a.c.monotype = function(a, b) {
        return new ra(b, a);
    };
    Y.a.c.typekit = function(a, b) {
        return new Ga(b, a);
    };
    Y.a.c.google = function(a, b) {
        return new Ea(b, a);
    };
    var Z = {
        load: p(Y.load, Y)
    };
    "function" === typeof define && define.amd ? define(function() {
        return Z;
    }) : (0, module.exports) ? module.exports = Z : (window.WebFont = Z, window.WebFontConfig && Y.load(window.WebFontConfig));
})();

});

/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ function $22f5f922ddc3e706$export$9c04d8fd885bb013(element, action, touchAction) {
    if ("ontouchstart" in window) {
        if (touchAction) element.addEventListener("touchstart", touchAction, {
            passive: false
        });
        else element.addEventListener("touchstart", action, {
            passive: false
        });
    } else element.addEventListener("mousedown", action, {
        passive: false
    });
}
const $22f5f922ddc3e706$var$DragEventTypeNames = {
    "down": {
        t: "touchstart",
        m: "mousedown"
    },
    "up": {
        t: "touchend",
        m: "mouseup"
    },
    "move": {
        t: "touchmove",
        m: "mousemove"
    },
    "out": {
        t: "mousout",
        m: "mouseout"
    }
};
function $22f5f922ddc3e706$export$1669584523662bc1(element, type, handler) {
    const touchEventName = $22f5f922ddc3e706$var$DragEventTypeNames[type].t;
    const clickEventName = $22f5f922ddc3e706$var$DragEventTypeNames[type].m;
    const testname = "on" + touchEventName;
    if (testname in window) element.addEventListener(touchEventName, (e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
    }, {
        passive: false
    });
    else element.addEventListener(clickEventName, (e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler(e.clientX, e.clientY);
    }, {
        passive: false
    });
}
function $22f5f922ddc3e706$var$debugmsg(test) {
    document.getElementById("debugInfo").innerHTML = document.getElementById("debugInfo").innerHTML + "<br>" + test;
}
function $22f5f922ddc3e706$export$9a23bd5abbd0d648() {
    // Register gesturestart to prevent complex events
    document.addEventListener("gesturestart", (e)=>{
        e.preventDefault();
        $22f5f922ddc3e706$var$registerEvent("gesturestart");
    }, {
        passive: false
    });
    // Handle default mouse down OR touch start to prevent pinch zoom etc.
    $22f5f922ddc3e706$export$9c04d8fd885bb013(document, (e)=>{
        $22f5f922ddc3e706$var$registerEvent("prevent " + e.type);
        e.preventDefault();
    });
    // Catch move events
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) window.document.addEventListener("touchmove", (e)=>{
        $22f5f922ddc3e706$var$registerEvent("ios touch move");
        e.preventDefault();
    }, {
        passive: false
    });
}
function $22f5f922ddc3e706$var$registerEvent(name) {
    if (document.getElementById("messages")) document.getElementById("messages").innerHTML = name + "<br>" + document.getElementById("messages").innerHTML;
// if (top.document.getElementById('messages')) {
//   top.document.getElementById('messages').innerHTML = name + '<br>' + top.document.getElementById('messages').innerHTML;
// }
}


// Message to the platform

class $c39ed129cd641cb9$export$285343fddb570ac1 {
    constructor(){
        this.game = undefined;
        window.addEventListener("message", (ev)=>{
            this.receive(ev.data);
        });
        window.pew = this;
    }
    receive(data) {
        if (!this.game) {
            console.error("Error: Game not set");
            return;
        }
        switch(data.eventName){
            case "play":
                this.game.play(); // Send play message to the game
                break;
            case "restart":
                this.game.restart();
        }
    }
    init(game, config, keys) {
        this.game = game;
        // Load fonts and then send ready event
        let fonts = [];
        for (const key of keys){
            const value = config[key];
            if (!fonts.includes(value) && !$c39ed129cd641cb9$var$excludedFonts.includes(value)) fonts.push(value);
        }
        console.log(fonts);
        if (fonts.length > 0) Promise.resolve((parcelRequire("50i7i"))).then((webfont)=>{
            webfont.load({
                google: {
                    families: fonts
                },
                active: ()=>{
                    console.log("LETS GO");
                    this.ready();
                }
            });
        });
        else this.ready();
    }
    /**
	 * Retrieve play event when game actualy starts
	 */ gamestarted() {
        // console.log('G: SEND', 'play');
        this.sendEvent({
            eventName: "start"
        });
    }
    resume() {
        this.sendEvent({
            eventName: "resume"
        });
    }
    play() {
        this.game?.play();
    }
    /**
	 * Retrieve gameover event from game whith endsoce
	 */ gameover(score) {
        this.sendEvent({
            eventName: "gameover",
            data: {
                score: score
            }
        });
    }
    /**
	 * Receive ready event from game when allowed to use start
	 */ ready() {
        console.log("puzzle est ready");
        this.sendEvent({
            eventName: "ready"
        });
    }
    pause() {
        this.sendEvent({
            eventName: "pause"
        });
    }
    playSound(sound) {
        this.sendEvent({
            eventName: "sound",
            data: sound
        });
    }
    preloadSounds(config) {
        let files = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = config.path + "/" + v;
            if (!files.includes(value) && key.includes("Sound")) files.push(value);
        }
        console.log(files);
        this.sendEvent({
            eventName: "preload-sounds",
            data: files
        });
    }
    sendScore(score) {
        this.sendEvent({
            eventName: "score",
            data: {
                score: Math.round(score)
            }
        });
    }
    sendTimeleft(time, force = false) {
        this.sendEvent({
            eventName: "timeleft",
            data: time
        });
    }
    /**
	 * Send message to the game platform
	 * @param event
	 */ sendEvent(event) {
        window?.parent?.postMessage(event, "*");
    }
}
const $c39ed129cd641cb9$var$excludedFonts = [
    "Arial",
    "Helvetica",
    "Comic Sans MS",
    "Courier New",
    "Courier",
    "Georgia",
    "Lucida Sans Unicode",
    "Lucida Grande",
    "Geneva",
    "Times New Roman",
    "Trebuchet",
    "Verdana"
];


class $0fbb4cd18a8e495a$export$a54962065ab3aa65 {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
}
class $0fbb4cd18a8e495a$export$359f1ec75f22c35f {
    constructor(width, height){
        this.width = width;
        this.height = height;
    }
}


class $9a41e943904a04eb$export$936d0764594b6eb3 {
    constructor(tile, game){
        this.tiles$ = [];
        this.size = {
            height: 0,
            width: 0
        };
        this.position = {
            x: 0,
            y: 0
        };
        this.state = {
            animation: {
                active: false,
                startPos: {
                    x: 0,
                    y: 0
                },
                startTime: new Date(),
                targetPos: {
                    x: 0,
                    y: 0
                },
                duration: 0
            },
            zoom: false
        };
        const leftMargin = (game.sizes.canvas.width - game.sizes.puzzle.width) / 2 + game.config.puzzleBoxPadding;
        const topMargin = game.config.verticalMargin + (game.sizes.canvas.height - game.sizes.puzzle.height - game.config.verticalMargin - game.config.verticalMargin) / 2 + game.config.puzzleBoxPadding;
        this.position = {
            x: (tile.col - 1) * game.sizes.tile.width + leftMargin,
            y: (tile.row - 1) * game.sizes.tile.height + topMargin
        };
        this.game = game;
        this.addTile(tile);
        this.canvas = document.createElement("canvas");
        this.ctx = this.canvas.getContext("2d");
        this.updateLayerCanvas();
    }
    trySnap() {
        for(let x = 0; x < this.tiles$.length; x++){
            const tile = this.tiles$[x];
            const result = tile.checkSnap();
            if (result.length > 0) return result.shift().getLayer();
        }
        return null;
    }
    checkPosition(duration) {
        const canvasSize = this.game.sizes.canvas;
        console.log(this.size);
        const maxX = Math.floor(canvasSize.width - this.size.width - this.game.config.horizontalMargin);
        const maxY = Math.floor(canvasSize.height - this.size.height - this.game.config.verticalMargin);
        if (this.position.x < this.game.config.horizontalMargin || this.position.y < this.game.config.verticalMargin || this.position.x > maxX || this.position.y > maxY) {
            this.state.animation.startPos = this.position;
            this.state.animation.startTime = new Date();
            this.state.animation.targetPos = {
                x: Math.min(maxX, Math.max(this.game.config.horizontalMargin, this.position.x)),
                y: Math.min(maxY, Math.max(this.game.config.verticalMargin, this.position.y))
            };
            console.log(this.state.animation.targetPos);
            this.state.animation.active = true;
            this.state.animation.duration = duration;
            this.game.playSound(this.game.config.bounceSound);
        }
    }
    mergeLayer(droppedLayer) {
        // Get all row numbers in layer
        const rowNumbers = this.tiles$.map((tile)=>tile.row);
        const colNumbers = this.tiles$.map((tile)=>tile.col);
        // Find top and left tile position
        let leftCol = Math.min(...colNumbers);
        let topRow = Math.min(...rowNumbers);
        // Add all tiles from dragged layer to this layer
        droppedLayer.tiles$.forEach((tile)=>{
            // Layer extended above, move y of layer
            if (tile.row < topRow) {
                this.position.y = this.position.y - (topRow - tile.row) * this.game.sizes.tile.height;
                topRow = tile.row;
            }
            // Layer extended to left, move x of layer
            if (tile.col < leftCol) {
                this.position.x = this.position.x - (leftCol - tile.col) * this.game.sizes.tile.width;
                leftCol = tile.col;
            }
            // Register the tile
            this.addTile(tile);
        });
        this.game.removeLayer(droppedLayer);
        this.updateLayerCanvas();
    }
    coversPosition(position) {
        if (position.x < this.position.x) return false;
        if (position.y < this.position.y) return false;
        if (position.x > this.position.x + this.size.width) return false;
        if (position.y > this.position.y + this.size.height) return false;
        // whitin layer.
        // relative position:
        let found = false;
        const relPos = new (0, $0fbb4cd18a8e495a$export$a54962065ab3aa65)(position.x - this.position.x, position.y - this.position.y);
        this.tiles$.forEach((tile)=>{
            if (relPos.x < tile.position.x) return;
            if (relPos.y < tile.position.y) return;
            if (relPos.x > tile.position.x + this.game.sizes.tile.width) return;
            if (relPos.y > tile.position.y + this.game.sizes.tile.height) return;
            found = true;
        });
        return found;
    }
    getTileCount() {
        return this.tiles$.length;
    }
    getCanvas() {
        return this.canvas;
    }
    getSize() {
        return this.size;
    }
    getPosition() {
        return this.position;
    }
    updateAnimation() {
        if (!this.state.animation.active) return;
        const animation = this.state.animation;
        const timeDiff = new Date().getTime() - animation.startTime.getTime();
        // Target reached
        if (timeDiff > animation.duration) {
            this.position = animation.targetPos;
            this.state.animation.active = false;
            return;
        }
        // No duration
        if (animation.duration <= 0) {
            this.position = animation.targetPos;
            this.state.animation.active = false;
            return;
        }
        const progress = timeDiff / animation.duration; // x%
        const dX = animation.startPos.x - animation.targetPos.x;
        const dY = animation.startPos.y - animation.targetPos.y;
        const mX = dX * progress;
        const mY = dY * progress;
        const newX = this.easeInOutQuad(timeDiff, animation.startPos.x, animation.targetPos.x - animation.startPos.x, animation.duration);
        const newY = this.easeInOutQuad(timeDiff, animation.startPos.y, animation.targetPos.y - animation.startPos.y, animation.duration);
        // this.position = { x: animation.startPos.x - mX, y: animation.startPos.y - mY };
        this.position = {
            x: newX,
            y: newY
        };
    }
    // formula     http://easings.net/
    // description https://stackoverflow.com/questions/8316882/what-is-an-easing-function
    // x: percent
    // t: current time,
    // b: beginning value,
    // c: change in value,
    // d: duration
    easeInOutQuad(t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        else return -c / 2 * (--t * (t - 2) - 1) + b;
    }
    setPosition(newPosition, animated, duration) {
        if (animated) {
            if (!this.state.animation.active) this.state.animation.startPos = this.position;
            this.state.animation.startTime = new Date();
            this.state.animation.active = true;
            this.state.animation.targetPos = newPosition;
            this.state.animation.duration = duration;
        } else {
            this.state.animation.active = false;
            this.position = newPosition;
        }
    }
    setLayerSize(width, height) {
        this.size.width = width;
        this.size.height = height;
    }
    /***************************
	 * Private functions
	 ***************************/ /**
	 *
	 * @param tile
	 */ addTile(tile) {
        this.tiles$.push(tile);
        tile.setLayer(this);
    }
    updateLayerCanvas() {
        const rowNumbers = this.tiles$.map((tile)=>tile.row);
        const colNumbers = this.tiles$.map((tile)=>tile.col);
        const leftCol = Math.min(...colNumbers);
        const rightCol = Math.max(...colNumbers);
        const topRow = Math.min(...rowNumbers);
        const bottomRow = Math.max(...rowNumbers);
        const tileSize = this.game.sizes.tile;
        // Update layer size based on rows and cols in the layer
        this.size = {
            width: (rightCol - leftCol + 1) * tileSize.width,
            height: (bottomRow - topRow + 1) * tileSize.height
        };
        // Update tile positions whitin this layer
        this.tiles$.forEach((tile)=>{
            tile.setTilePosition({
                x: (tile.col - leftCol) * tileSize.width,
                y: (tile.row - topRow) * tileSize.height
            });
        });
        // Update canvas size and place all tiles
        this.canvas.width = this.size.width;
        this.canvas.height = this.size.height;
        // Clean layer
        this.ctx.clearRect(0, 0, this.size.width, this.size.height);
        // Add tiles
        this.tiles$.forEach((tile)=>{
            tile.drawTile(this.canvas);
        });
    }
    updateSizes() {
        this.tiles$.forEach((t)=>{
            t.repaint();
        });
        this.updateLayerCanvas();
    }
    get zoom() {
        return this.state.zoom;
    }
    setZoom(value) {
        this.state.zoom = value;
    }
}


class $294a9ab98e704f61$export$235cb65c20ad2b7 {
    constructor(gameObject, col, row){
        this.position$ = {
            x: 0,
            y: 0
        };
        this.snappableTiles = [];
        this.gameObject = gameObject;
        this.row = row;
        this.col = col;
        // Register all tiles around this one
        this.snappableTiles = [];
        if (this.row > 1) this.snappableTiles.push({
            row: row - 1,
            col: col,
            position: "above"
        });
        if (this.row < this.gameObject.state.level.rows) this.snappableTiles.push({
            row: row + 1,
            col: col,
            position: "below"
        });
        if (this.col > 1) this.snappableTiles.push({
            row: row,
            col: col - 1,
            position: "left"
        });
        if (this.col < this.gameObject.state.level.cols) this.snappableTiles.push({
            row: row,
            col: col + 1,
            position: "right"
        });
        this.canvas = document.createElement("canvas");
        this.repaint();
    }
    repaint() {
        this.canvas.width = this.gameObject.sizes.tile.width;
        this.canvas.height = this.gameObject.sizes.tile.height;
        const context = this.canvas.getContext("2d");
        if (context) context.drawImage(this.gameObject.getImage(), (this.col - 1) * this.gameObject.sizes.sourceTile.width, (this.row - 1) * this.gameObject.sizes.sourceTile.height, this.gameObject.sizes.sourceTile.width, this.gameObject.sizes.sourceTile.height, 0, 0, this.canvas.width, this.canvas.height);
    }
    checkSnap() {
        const myPos = this.getCanvasPosition();
        const foundSnapTiles = [];
        this.snappableTiles.forEach((tile)=>{
            const p = this.gameObject.getTile(tile.row, tile.col);
            if (p.getLayer() === this.getLayer()) return;
            const snapMarge = this.gameObject.config.snapMarge;
            const tilePos = p.getCanvasPosition();
            const targetYWithMarge = tilePos.y + this.gameObject.sizes.tile.height + snapMarge;
            const targetXWithMarge = tilePos.x + this.gameObject.sizes.tile.width + snapMarge;
            const myPosX = myPos.x + this.gameObject.sizes.tile.width + snapMarge;
            const myPosY = myPos.y + this.gameObject.sizes.tile.height + snapMarge;
            switch(tile.position){
                case "above":
                    if (targetYWithMarge - myPos.y >= 0 - snapMarge && targetYWithMarge - myPos.y <= snapMarge && tilePos.x - myPos.x <= snapMarge && myPosX - targetXWithMarge <= snapMarge) {
                        foundSnapTiles.push(p);
                        console.log("ik wil naar boven snappen!");
                    }
                    break;
                case "below":
                    if (myPos.y + this.gameObject.sizes.tile.height - tilePos.y <= snapMarge && myPos.y + this.gameObject.sizes.tile.height - tilePos.y >= -snapMarge && tilePos.x - myPos.x <= snapMarge && tilePos.x - myPos.x >= -snapMarge) {
                        foundSnapTiles.push(p);
                        console.log("ik wil naar onder snappen!");
                    }
                    break;
                case "left":
                    if (targetXWithMarge - myPos.x <= snapMarge && targetXWithMarge - myPos.x >= 0 - snapMarge && tilePos.y - myPos.y <= snapMarge && myPosY - targetYWithMarge <= snapMarge) {
                        foundSnapTiles.push(p);
                        console.log("ik wil naar links snappen!");
                    }
                    break;
                case "right":
                    if (myPosX - tilePos.x - snapMarge >= -snapMarge && myPosX - tilePos.x - snapMarge <= snapMarge && tilePos.y - myPos.y <= snapMarge && myPosY - targetYWithMarge <= snapMarge) {
                        foundSnapTiles.push(p);
                        console.log("ik wil naar rechts snappen!");
                    }
                    break;
            }
        });
        return foundSnapTiles;
    }
    getCanvasPosition() {
        return {
            x: this.position$.x + this.layer.getPosition().x,
            y: this.position$.y + this.layer.getPosition().y
        };
    }
    //connected tiles
    getAdjacentTiles() {
        return this.snappableTiles;
    }
    // Place this tile on a canvas
    drawTile(targetCanvas) {
        // this.clearTile(canvas);
        const ctx = targetCanvas.getContext("2d");
        ctx.drawImage(this.canvas, this.position$.x, this.position$.y, this.gameObject.sizes.tile.width, this.gameObject.sizes.tile.height);
    }
    clearTile(canvas) {
        const context = canvas.getContext("2d");
        context.clearRect(this.position$.x, this.position$.y, this.gameObject.sizes.tile.width, this.gameObject.sizes.tile.height);
    }
    setLayer(layer) {
        this.layer = layer;
    }
    getLayer() {
        return this.layer;
    }
    getCanvas() {
        return this.canvas;
    }
    getTilePosition() {
        return this.position$;
    }
    get position() {
        return this.position$;
    }
    setTilePosition(newPosition) {
        this.position$ = newPosition;
    }
}


function $13819832244ecdd6$export$805b7e535d2a0787(ctx, position, size, inputRadius = 5, fill = false, stroke = true) {
    const x = position.x;
    const y = position.y;
    const w = size.width;
    const h = size.height;
    let radius;
    let radiusParts;
    switch(typeof inputRadius){
        case "number":
            radius = {
                tl: inputRadius,
                tr: inputRadius,
                br: inputRadius,
                bl: inputRadius
            };
            break;
        case "string":
            radiusParts = inputRadius.trim().split(" ");
            if (radiusParts.length === 2) radius = {
                tl: +radiusParts[0],
                tr: +radiusParts[0],
                br: +radiusParts[1],
                bl: +radiusParts[1]
            };
            break;
        case "object":
            radius = inputRadius;
            break;
    }
    const defaultRadius = {
        tl: 0,
        tr: 0,
        br: 0,
        bl: 0
    };
    for(const side in defaultRadius)radius[side] = radius[side] || defaultRadius[side];
    let r = radius.bl;
    if (w < 2 * r) r = w / 2;
    if (h < 2 * r) r = h / 2;
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
    // ctx.stroke();
    // return;
    // ctx.beginPath();
    // ctx.moveTo(x + radius.tl, y);
    // ctx.lineTo(x + width - radius.tr, y);
    // ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
    // ctx.lineTo(x + width, y + height - radius.br);
    // ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
    // ctx.lineTo(x + radius.bl, y + height);
    // ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
    // ctx.lineTo(x, y + radius.tl);
    // ctx.quadraticCurveTo(x, y, x + radius.tl, y);
    // ctx.closePath();
    if (fill) ctx.fill();
    if (stroke) ctx.stroke();
}


class $2eef3a05e8cd06fb$export$c672d870a5fac9b {
    constructor(gameObject, canvas){
        this.gameObject = gameObject;
        this.canvas = canvas;
        this.context = canvas.getContext("2d");
    }
    init() {
        document.getElementById("myBar").style.backgroundColor = this.gameObject.config.timeBarColor;
        document.getElementById("myProgress").style.top = 60 + this.gameObject.config.timeBarOffsetY + "px";
        document.getElementById("myProgress").style.visibility = "hidden";
        document.getElementById("myProgress").style.borderColor = this.gameObject.config.timeBarBorderColor;
        document.getElementById("myProgress").style.borderWidth = this.gameObject.config.timeBarBorderWidth + "px";
        document.getElementById("myProgress").style.borderRadius = this.gameObject.config.timeBarBorderRadius + "px";
        document.getElementById("myBarBackground").style.backgroundColor = this.gameObject.config.timeBarBackgroundColor;
        document.getElementById("myBar").style.width = "100%";
    }
    update() {
        // teken balk
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (this.gameObject.state.gameState === "init") return;
        this.drawPlaceholder();
        if (this.gameObject.config.useTime && this.gameObject.state.showBars) this.drawTimerBar();
        this.drawLayers();
    }
    drawLayers() {
        this.gameObject.layers.forEach((layer)=>{
            layer.updateAnimation();
            if (layer.zoom) this.context.drawImage(layer.getCanvas(), layer.getPosition().x * 0.98, layer.getPosition().y * 0.98, layer.getSize().width * 1.02, layer.getSize().height * 1.02);
            else this.context.drawImage(layer.getCanvas(), layer.getPosition().x, layer.getPosition().y, layer.getSize().width, layer.getSize().height);
        });
    }
    drawPlaceholder() {
        // Background
        this.context.fillStyle = this.gameObject.config.puzzleBoxColor;
        this.context.globalAlpha = this.gameObject.config.puzzleBoxOpacity;
        const puzzleSize = {
            ...this.gameObject.sizes.puzzle
        };
        puzzleSize.width = Math.floor(puzzleSize.width);
        puzzleSize.height = Math.floor(puzzleSize.height);
        const puzzlePosition = {
            x: (this.gameObject.sizes.canvas.width - puzzleSize.width) / 2,
            y: this.gameObject.config.verticalMargin + (this.gameObject.sizes.canvas.height - this.gameObject.config.verticalMargin - this.gameObject.config.verticalMargin - puzzleSize.height) / 2
        };
        // puzzlePosition.x = puzzlePosition.x * 1.1;
        // puzzlePosition.y = puzzlePosition.y * 1.1;
        (0, $13819832244ecdd6$export$805b7e535d2a0787)(this.context, puzzlePosition, puzzleSize, this.gameObject.config.puzzleBoxBorderRadius, true, false);
        this.context.globalAlpha = 1.0;
    }
    drawTimerBar() {
        const timePercentage = this.gameObject.state.progress;
        // Progress
        if (timePercentage < 100) // (<HTMLElement>document.getElementById("myBar")).style.width =
        // 	timePercentage + "%";
        this.gameObject.platform.sendTimeleft(timePercentage, this.gameObject.state.gameState != "playing" && !this.gameObject.waitForCenterAnimation);
    }
    checkCoordinates(position) {
        for(let x = this.gameObject.layers.length - 1; x >= 0; x--){
            if (this.gameObject.layers[x].coversPosition(position)) return this.gameObject.layers[x];
        }
        return null;
    }
}


"use strict";
const $edbc113ca4cb4d72$export$ac4f8128ea29c5 = {
    path: "https://gamecdn.playenwin.com/wietse/puzzel/default",
    levels: "foto.png,1x3,10;default.jpg,1x2,20",
    pointsPerTile: 100,
    useTime: false,
    pointsPerMs: 1,
    snapMarge: 50,
    scoreOffsetY: 0,
    puzzleSize: 90,
    verticalMargin: 80,
    horizontalMargin: 10,
    puzzleBoxColor: "#fff",
    puzzleBoxOpacity: 0.4,
    puzzleBoxBorderRadius: 50,
    puzzleBoxPadding: 10,
    btnColor: "#483B6F",
    btnFont: "Acme",
    btnFontSize: 50,
    btnFontColor: "#FFFFFF",
    btnBorderRadius: 10,
    showTimeBox: false,
    timeBoxFont: "Bonbon",
    timeBoxBorderRadius: 20,
    timeBoxColor: "black",
    timeBoxFontColor: "white",
    timeBoxFontSize: 20,
    popupBackgroundColor: "#ffffffcc",
    popupBorderRadius: 30,
    popupFont: "Arial",
    popupFontSize: 20,
    popupFontColor: "black",
    scoreFontSize: 30,
    scoreFontColor: "#FFF",
    scoreFont: "Acme",
    timeBarBorderColor: "#1d3544",
    timeBarColor: "#ed8b00",
    timeBarBackgroundColor: "#fff",
    timeBarBorderRadius: 0,
    timeBarBorderWidth: 0,
    timeBarOffsetY: 0,
    shuffleTime: 500,
    mergeBounceTime: 1000,
    bounceTime: 250,
    gameOverTime: 4000,
    previewTime: 2000,
    nextLevelTime: 1000,
    solvedMessage: "Puzzel opgelost goed gedaan!",
    timeupMessage: "Time's up !",
    previewMessage: "Get ready",
    showShuffle: true,
    showStop: true,
    btnYesText: "Ja",
    btnNoText: "Nee",
    btnOkText: "Ok",
    btnShuffleText: "Shuffle",
    btnStopText: "Stop",
    finishedMessage: "Je hebt alle puzzel opgelost!",
    overlayColor: "#00000066",
    pauseText: "Pauze",
    solvedCenterTime: 4000,
    stopMessage: "Weet je zeker dat je wilt stoppen?",
    shuffleSound: "",
    levelFinishedSound: "",
    snapSound: "",
    pickUpSound: "",
    releaseSound: "",
    timeBonusSound: "",
    btnClickSound: "",
    gameFinishedSound: "",
    bounceSound: ""
};



var $50i7i = parcelRequire("50i7i");
class $e45ba02351190ebe$export$f807d9a22ff8372d {
    onlyUnique(value, index, array) {
        return array.indexOf(value) === index;
    }
    getWebFonts(config) {
        const fonts = [
            config.popupFont,
            config.scoreFont,
            config.btnFont,
            config.timeBoxFont
        ];
        return fonts.filter(this.onlyUnique);
    }
    loadConfig() {
        const config = this.getDefault();
        this.patch(config);
        this.printConfig(config);
        $50i7i.load({
            google: {
                families: this.getWebFonts(config)
            }
        });
        return config;
    }
    getDefault() {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.get("v");
        return 0, $edbc113ca4cb4d72$export$ac4f8128ea29c5;
    }
    patch(config) {
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.get("s")) return;
        const settings = atob(urlParams.get("s")).split("\n").filter((s)=>s.trim() !== "").filter((s)=>s.substr(0, 1) !== "#").map((s)=>{
            return {
                name: s.split("=")[0].trim(),
                value: s.split("=")[1].trim()
            };
        });
        settings.forEach((s)=>{
            if (!isNaN(+s.value)) config[s.name] = +s.value;
            else if (s.value === "true") config[s.name] = true;
            else if (s.value === "false") config[s.name] = false;
            else config[s.name] = s.value;
        });
        console.log(config);
    }
    printConfig(config) {
        let string = "";
        for (const [key, value] of Object.entries(config))string += key + "=" + value + "\n";
        console.log(string);
    }
}


class $d40c66511ed43fb6$export$a5570310586623e4 {
    setPath(path, antiCache = false) {
        this.path = path;
        this.antiCache = antiCache;
    }
    preload(list, cb) {
        this.cb = cb;
        list.forEach((imgname)=>{
            this.addImage(imgname);
        });
    }
    addImage(name) {
        if (this.getimage(name)) return;
        const image = {
            filename: name,
            object: new Image(),
            loaded: false
        };
        image.object.src = this.path + "/" + name + (this.antiCache ? "?" + Date.now() : "");
        image.object.addEventListener("load", ()=>this.onload(image));
        image.object.addEventListener("error", (e)=>this.onloadError(e, image));
        this.imageList.push(image);
    }
    onload(image) {
        image.loaded = true;
        this.readyCount++;
        this.check();
    }
    getimage(name) {
        return this.imageList.find((i)=>i.filename === name) || null;
    }
    onloadError(e, image) {
        console.error("image", this.path + "/" + image.filename, "not found");
        image.error = true;
        this.readyCount++;
        this.check();
    }
    check() {
        if (this.readyCount === this.imageList.length) {
            console.log("all images are loaded");
            if (this.cb) this.cb();
        }
    }
    constructor(){
        this.imageList = [];
        this.images = [];
        this.readyCount = 0;
    }
}


/**
 * Add drag tracking functionality for single toch point
 * @Author Jeroen van der Molen / AuguSoft
 */ // interface for registered event handlers
class $467fbc40a9cf272b$export$d23484e29a0c570 {
    constructor(elm, startHandler, moveHandler, dropHandler){
        this.enableTouch = false;
        this.firstTouch = null;
        this.elm = elm;
        this.enableTouch = "ontouchstart" in window;
        this.startHandler = startHandler;
        this.moveHandler = moveHandler;
        this.dropHandler = dropHandler;
        if (this.enableTouch) this.registerTouchEvents();
        else this.registerMouseEvents();
    }
    // Register all touch event
    registerTouchEvents() {
        this.elm.addEventListener("touchstart", this.touchstart.bind(this));
        this.elm.addEventListener("touchmove", this.touchmove.bind(this));
        this.elm.addEventListener("touchend", this.touchend.bind(this));
    }
    /**
   * Simple mouse events
   */ registerMouseEvents() {
        this.elm.addEventListener("mousedown", this.mousedown.bind(this));
        this.elm.addEventListener("mousemove", this.mousemove.bind(this));
        this.elm.addEventListener("mouseup", this.mouseup.bind(this));
        this.elm.addEventListener("mouseout", this.mouseup.bind(this));
    }
    touchstart(e) {
        e.preventDefault;
        e.stopPropagation();
        // Active first touchpoint and still exists, ignore start event
        if (this.firstTouch !== null && this.findTouch(e.touches, this.firstTouch)) return;
        if (this.firstTouch !== null) // First touch is set, but not found anymore
        console.error("active touch point does not exist anymore");
        // Register first touchpoint
        this.firstTouch = e.changedTouches[0].identifier;
        return this.startHandler(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
    }
    touchmove(e) {
        e.stopPropagation();
        e.stopPropagation();
        // If no first touch is preset, just ignore this call
        if (this.firstTouch === null) return;
        // If first touch is not found in changes, ignore this call
        const activeTouch = this.findTouch(e.changedTouches, this.firstTouch);
        if (activeTouch === null) return;
        return this.moveHandler(activeTouch.clientX, activeTouch.clientY);
    }
    touchend(e) {
        e.stopPropagation();
        e.stopPropagation();
        // If no first touch is preset, just ignore this call
        if (this.firstTouch === null) return;
        // If first touch is not found in changes, ignore this call
        const activeTouch = this.findTouch(e.changedTouches, this.firstTouch);
        if (activeTouch === null) return;
        // The registered touchpoint is ended, unregister touchpoint and send position
        this.firstTouch = null;
        return this.dropHandler(activeTouch.clientX, activeTouch.clientY);
    }
    mousedown(e) {
        e.preventDefault;
        e.stopPropagation();
        this.startHandler(e.clientX, e.clientY);
    }
    mousemove(e) {
        e.preventDefault;
        e.stopPropagation();
        this.moveHandler(e.clientX, e.clientY);
    }
    mouseup(e) {
        e.preventDefault;
        e.stopPropagation();
        this.dropHandler(e.clientX, e.clientY);
    }
    // Find touch event based on ID
    findTouch(touchList, id) {
        for(let i = 0; i < touchList.length; i++){
            if (touchList[i].identifier === id) return touchList[i];
        }
        return null;
    }
}


"use strict";
class $ee901c93ece588f3$export$740547f5752a17b4 {
    get config() {
        return this.config$;
    }
    get sizes() {
        return this.sizes$;
    }
    get state() {
        return this.state$;
    }
    get layers() {
        return this.layers$;
    }
    constructor(){
        this.ELMcanvas = document.getElementById("myCanvas");
        this.ELMScoreContainer = document.getElementById("score");
        this.debug = false;
        this.layers$ = [];
        this.tiles$ = [];
        this.levels$ = [];
        this.state$ = {
            gameState: "init",
            score: 0,
            dragging: false,
            startTime: new Date(),
            activeLevel: 0,
            progress: 0,
            level: null,
            displayTime: "",
            paused: false,
            pauseTime: null,
            showBars: false,
            resultsend: false
        };
        this.dragCorrection = {
            x: 0,
            y: 0
        };
        this.waitForCenterAnimation = false;
        this.sounds = {
            shuffleSound: "",
            levelFinishedSound: "",
            snapSound: "",
            pickUpSound: "",
            releaseSound: "",
            timeBonusSound: "",
            btnClickSound: "",
            gameFinishedSound: "",
            bounceSound: ""
        };
        if (window.location.search.search("debug") !== -1) this.debug = true;
        // Load utilities
        this.canvas$ = new (0, $2eef3a05e8cd06fb$export$c672d870a5fac9b)(this, this.ELMcanvas);
        this.preloader = new (0, $d40c66511ed43fb6$export$a5570310586623e4)();
        this.configurator = new (0, $e45ba02351190ebe$export$f807d9a22ff8372d)();
        this.platform = new (0, $c39ed129cd641cb9$export$285343fddb570ac1)();
        (0, $22f5f922ddc3e706$export$9a23bd5abbd0d648)(); // Prevent zoom etc.
        this.loadConfig();
        // Preload images and call init afterwards. Requires images to be loadeds
        this.preloadImages(this.init.bind(this));
        this.initToolbar();
        this.platform.preloadSounds(this.config);
    }
    // Receive play message from platform
    play() {
        this.preview();
    }
    // Retrieve a tile based on row and column
    getTile(row, col) {
        return this.tiles$.find((tile)=>{
            return tile.row === row && tile.col === col;
        });
    }
    // get the active image
    getImage() {
        return this.preloader.getimage(this.state$.level.image).object;
    }
    removeLayer(dragLayer) {
        for(let i = 0; i < this.layers$.length; i++)if (this.layers$[i] === dragLayer) {
            this.layers$.splice(i, 1);
            i--;
            return;
        }
    }
    loadConfig() {
        this.config$ = this.configurator.loadConfig();
        this.levels$ = [];
        if (this.config$.levels) this.config$.levels.split(";").forEach((ld)=>{
            const parts = ld.trim().split(",").map((p)=>p.trim());
            if (parts.length !== 3) throw Error("Invalid level" + ld);
            const sizeParts = parts[1].trim().split("x").map((p)=>p.trim());
            if (sizeParts.length !== 2) throw Error("Invalid level" + ld);
            this.levels$.push({
                image: parts[0],
                rows: +sizeParts[0],
                cols: +sizeParts[1],
                duration: +parts[2] / 1000
            });
        });
    }
    // Preload images and call callback on success
    preloadImages(cb) {
        this.preloader.setPath(this.config$.path);
        const imagelist = this.levels$.map((l)=>l.image);
        this.preloader.preload(imagelist, cb);
    }
    // Called after preloader
    init() {
        console.warn("INIT");
        this.patchCss();
        this.canvas$.init();
        // Basic state
        this.resetState();
        // Do not allow events before
        this.registerEvents();
        // Load first game
        // Load next level
        this.loadlevel();
        // Start loop
        setTimeout(()=>{
            this.platform.init(this, this.config$, [
                "btnFont",
                "popupFont",
                "timeBoxFont",
                "scoreFont"
            ]);
        }, 10);
        this.nextFrame();
        // Prepare first game
        this.prepareGame();
    }
    resetState() {
        console.log("initState");
        // Load the inital state of a game
        this.state$ = {
            gameState: "ready",
            score: 0,
            dragging: false,
            startTime: new Date(),
            activeLevel: 0,
            pauseTime: null,
            paused: false,
            displayTime: "",
            progress: 100,
            resultsend: false,
            showBars: false
        };
        this.closePopup();
        document.getElementById("buttonBar").classList.remove("open2");
        document.getElementById("buttonBar").classList.remove("open");
        document.getElementById("myBar").style.width = "100%";
    }
    handleResize() {
        // recalculate sizes
        this.initSizes();
        this.layers$.forEach((l)=>{
            l.updateSizes();
        });
    }
    initSizes() {
        // Scale canvas content to full size of element
        this.ELMcanvas.width = this.ELMcanvas.offsetWidth;
        this.ELMcanvas.height = this.ELMcanvas.offsetHeight;
        const canvasSize = {
            width: this.ELMcanvas.offsetWidth,
            height: this.ELMcanvas.offsetHeight
        };
        const imageSize = {
            width: this.getImage().width,
            height: this.getImage().height
        };
        const imageRatio = imageSize.width / imageSize.height;
        const maxPuzzleSize = {
            width: canvasSize.width * (this.config$.puzzleSize / 100),
            height: canvasSize.height * (this.config$.puzzleSize / 100)
        };
        const newHeight = maxPuzzleSize.width / imageRatio;
        const puzzleSize = newHeight > maxPuzzleSize.height // Too large
         ? {
            width: maxPuzzleSize.height * imageRatio,
            height: maxPuzzleSize.height
        } : {
            width: maxPuzzleSize.width,
            height: maxPuzzleSize.width / imageRatio
        };
        // Read real size of canvas element
        const sourceTileSize = {
            width: this.getImage().width / this.state.level.cols,
            height: this.getImage().height / this.state.level.rows
        };
        const tileSize = {
            width: (puzzleSize.width - this.config$.puzzleBoxPadding * 2) / this.state.level.cols,
            height: (puzzleSize.height - this.config$.puzzleBoxPadding * 2) / this.state.level.rows
        };
        this.sizes$ = {
            canvas: canvasSize,
            puzzle: puzzleSize,
            tile: tileSize,
            sourceTile: sourceTileSize
        };
    }
    // Create gameCanvas object and add all layers and tile
    prepareGame() {
        this.resetState();
        this.loadlevel();
    // When state is ready, start drawing;
    // this.setGameState('ready');
    // Send message to platform we are ready to receive play events
    // this.pew.init(this, () => {
    //   this.pew.ready();
    // });
    }
    loadlevel() {
        this.closePopup();
        this.state$.level = this.levels$[this.state$.activeLevel];
        this.state$.progress = 100;
        this.state$.displayTime = "0:00";
        // Change state
        this.state$.startTime = new Date();
        this.state$.showBars = false;
        this.initSizes();
        this.layers$ = [];
        this.tiles$ = this.createTiles();
        this.tiles$.forEach((tile)=>{
            this.layers$.push(new (0, $9a41e943904a04eb$export$936d0764594b6eb3)(tile, this));
        });
    }
    createTiles() {
        const result = [];
        for(let row = 0; row < this.state.level.rows; row++)for(let col = 0; col < this.state.level.cols; col++)result.push(new (0, $294a9ab98e704f61$export$235cb65c20ad2b7)(this, col + 1, row + 1));
        return result;
    }
    showPopup(message, buttons) {
        const buttonBar = document.getElementById("popupButtons");
        while(buttonBar.firstChild)buttonBar.removeChild(buttonBar.lastChild);
        buttons.forEach((b)=>{
            const button = document.createElement("div");
            button.classList.add("btn");
            button.addEventListener("click", ()=>{
                this.playSound("btnClick");
            });
            (0, $22f5f922ddc3e706$export$9c04d8fd885bb013)(button, b.event);
            button.innerHTML = b.caption;
            buttonBar.appendChild(button);
        });
        document.getElementById("message").innerHTML = message;
        document.getElementById("popup").style.display = "block";
    }
    closePopup() {
        document.getElementById("popup").style.display = "none";
    }
    // Go to next level and show preview
    nextLevel() {
        this.state$.activeLevel++;
        this.loadlevel();
        // (<HTMLElement>document.getElementById("myProgress")).style.visibility =
        //   "hidden";
        this.platform.sendTimeleft(100, true);
        this.preview();
    }
    addLayerScore() {
        this.state$.score += this.config$.pointsPerTile;
        this.updateScore();
    }
    dragStart(mouseX, mouseY) {
        if (this.state$.paused) return this.resume();
        const rect = this.ELMcanvas.getBoundingClientRect();
        const gameX = mouseX - rect.left;
        const gameY = mouseY - rect.top;
        // If ready, start timer on first down event
        // if (this.state$.gameState === 'ready') {
        //   // this.setGameState("preview");
        //   this.start();
        //   return;
        // }
        // If not playing, no further events
        if (this.state$.gameState !== "playing") {
            if (this.dragLayer) this.dragLayer.setZoom(false);
            this.dragLayer = null;
            this.state$.dragging = false;
            this.dragCorrection = {
                x: 0,
                y: 0
            };
            return;
        }
        // Find object
        this.dragLayer = this.canvas$.checkCoordinates({
            x: gameX,
            y: gameY
        });
        //
        if (!this.dragLayer) return;
        // A  layer is found on the coordinates.
        // Start dragging
        this.state$.dragging = true;
        this.dragLayer.setZoom(true);
        this.playSound("pickUp");
        // Move layer to top
        for(let i = 0; i < this.layers$.length; i++)if (this.layers$[i] === this.dragLayer) {
            this.layers$.splice(i, 1);
            this.layers$.push(this.dragLayer);
        }
        // Register correctiong for dragging
        this.dragCorrection = {
            x: gameX - this.dragLayer.getPosition().x,
            y: gameY - this.dragLayer.getPosition().y
        };
    }
    dragMove(mouseX, mouseY) {
        if (!this.state$.dragging) return;
        if (!this.dragLayer) {
            this.state$.dragging = false;
            return;
        }
        const rect = this.ELMcanvas.getBoundingClientRect();
        const gameX = mouseX - rect.left;
        const gameY = mouseY - rect.top;
        this.dragLayer.setPosition({
            x: gameX - this.dragCorrection.x,
            y: gameY - this.dragCorrection.y
        }, false);
    }
    dragEnd() {
        this.state$.dragging = false;
        if (!this.dragLayer) return;
        const snaplayer = this.dragLayer.trySnap();
        // If a layer to snap is found, Merge the draglayer
        if (snaplayer) {
            this.playSound("snap");
            snaplayer.mergeLayer(this.dragLayer);
            this.addLayerScore(); // Receive points
            snaplayer.checkPosition(this.config$.mergeBounceTime); // Check if the position of the merged layer is outside canvas.
        } else {
            this.playSound("release");
            this.dragLayer.checkPosition(this.config$.bounceTime); // Check position of the drag layer if not snapped. Animate back to canvas
        }
        // Remove zoom from the draglayer
        this.dragLayer.setZoom(false);
        this.dragLayer = null;
    }
    checkWinCondition() {
        return this.layers$.length === 1;
    }
    registerEvents() {
        new (0, $467fbc40a9cf272b$export$d23484e29a0c570)(this.ELMcanvas, this.dragStart.bind(this), this.dragMove.bind(this), this.dragEnd.bind(this));
        window.addEventListener("resize", ()=>this.handleResize());
        document.addEventListener("blur", ()=>{
            this.showPause();
        // Pause on blur?
        }, {
            passive: false
        });
        window.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "hidden") this.showPause();
        }, {
            passive: false
        });
        // Safari
        document.addEventListener("pagehide", ()=>{
            this.showPause();
        }, {
            passive: false
        });
    }
    pause() {
        // Set pausetime flag.
        if (!this.state$.paused) {
            this.state$.paused = true;
            this.state$.pauseTime = new Date();
        }
    }
    resume() {
        if (this.state$.paused) {
            this.state$.startTime.setTime(this.state$.startTime.getTime() + (new Date().getTime() - this.state$.pauseTime.getTime()));
            this.state$.pauseTime = null;
            this.state$.paused = false;
            this.closePopup();
        }
    }
    shuffleChaotic() {
        let randomX;
        let randomY;
        const max = {
            x: this.sizes$.canvas.width - this.sizes$.tile.width - this.config$.horizontalMargin,
            y: this.sizes$.canvas.height - this.sizes$.tile.height - this.config$.verticalMargin
        };
        this.layers$.sort(this.compareLayers);
        this.layers$.reverse();
        this.layers$.forEach((layer)=>{
            if (layer.getTileCount() <= 1) {
                randomX = this.getRandomNumber(this.config$.horizontalMargin, max.x);
                randomY = this.getRandomNumber(this.config$.verticalMargin, max.y);
                layer.setPosition({
                    x: randomX,
                    y: randomY
                }, true, this.config$.shuffleTime);
            }
        });
    }
    shuffleOrdered() {
        let randomX;
        let randomY;
        const center = {
            x: this.sizes$.canvas.width / 2 - this.sizes$.tile.width / 2,
            y: this.sizes$.canvas.height / 2 - this.sizes$.tile.height / 2
        };
        this.layers$.sort(this.compareLayers);
        this.layers$.reverse();
        this.layers$.forEach((layer)=>{
            if (layer.getTileCount() <= 1) {
                let position = this.getRandomPosition();
                console.log(position);
                switch(position){
                    case "top":
                        randomX = center.x + this.getRandomNumber(-this.sizes$.puzzle.width / 2, this.sizes$.puzzle.width / 2);
                        randomY = center.y - this.sizes$.puzzle.height / 2 - this.sizes$.tile.height / 2 - 5;
                        break;
                    case "bottom":
                        randomX = center.x + this.getRandomNumber(-this.sizes$.puzzle.width / 2, this.sizes$.puzzle.width / 2);
                        randomY = center.y + this.sizes$.puzzle.height / 2 + this.sizes$.tile.height / 2 + 5, this.sizes$.canvas.height, this.config$.verticalMargin, this.sizes$.tile.height;
                        break;
                    case "left":
                        randomX = center.x - this.sizes$.puzzle.width / 2 - this.sizes$.tile.width / 2 - 5;
                        randomY = center.y + this.getRandomNumber(-this.sizes$.puzzle.height / 2, this.sizes$.puzzle.height / 2);
                        break;
                    case "right":
                        randomX = center.x + this.sizes$.puzzle.width / 2 + this.sizes$.tile.width / 2 + 5;
                        randomY = center.y + this.getRandomNumber(-this.sizes$.puzzle.height / 2, this.sizes$.puzzle.height / 2);
                        break;
                }
                randomX = Math.max(randomX, this.config$.horizontalMargin);
                randomX = Math.min(randomX, this.sizes$.canvas.width - this.sizes$.tile.width - this.config$.horizontalMargin);
                randomY = Math.max(randomY, this.config$.verticalMargin);
                randomY = Math.min(randomY, this.sizes$.canvas.height - this.sizes$.tile.height - this.config$.verticalMargin);
                layer.setPosition({
                    x: randomX,
                    y: randomY
                }, true, this.config$.shuffleTime);
            }
        });
    }
    // Shuffle all layers with 1 piece
    shuffleTiles() {
        this.playSound("shuffle");
        if (this.layers$.find((layer)=>layer.getTileCount() > 1) === undefined) this.shuffleChaotic();
        else this.shuffleOrdered();
    }
    getRandomPosition() {
        const random = Math.random() * 4;
        if (random < 1) return "top";
        else if (random > 1 && random < 2) return "right";
        else if (random > 2 && random < 3) return "bottom";
        else return "left";
    }
    doesTileCollideWithTiles(tile, tiles) {
        tiles.forEach((layer)=>{
            let tile2 = {
                top: layer.getPosition().y,
                bottom: layer.getPosition().y + this.sizes$.tile.height,
                left: layer.getPosition().x,
                right: layer.getPosition().x + this.sizes$.tile.width
            };
            if (this.doRectanglesCollide(tile, tile2)) return true;
        });
        return false;
    }
    doRectanglesCollide(a, b) {
        let widthIsPositive = Math.min(a.right, b.right) > Math.max(a.left, b.left);
        let heightIsPositive = Math.min(a.bottom, b.bottom) > Math.max(a.top, b.top);
        return widthIsPositive && heightIsPositive;
    }
    compareLayers(layer1, layer2) {
        if (layer1.getTileCount() < layer2.getTileCount()) return -1;
        if (layer1.getTileCount() > layer2.getTileCount()) return 1;
        return 0;
    }
    getRandomNumber(min, max) {
        return Math.round(Math.random() * (max - min) + min);
    }
    addProgressPoint() {
        if (this.state$.progress > 0) {
            const maxScore = this.state$.level.duration * this.config$.pointsPerMs * 1000;
            const percentScore = maxScore / 100;
            this.state$.score += percentScore;
            this.state$.progress = Math.max(0, this.state$.progress - 1); // Remove 1 percent;
        }
        this.playSound("timeBonus", false);
        this.updateScore();
    }
    restart() {
        this.prepareGame();
        this.platform.ready();
    }
    doEvents() {
        // While in init state, nothing can be painted yet.
        if (this.state$.paused) {
            this.nextFrame();
            // Do nothing
            return;
        }
        switch(this.state$.gameState){
            case "init":
                this.nextFrame();
                return;
            // While playing. Update time and check for gameover and solved
            case "playing":
                this.updateRemainingTime();
                if (this.config$.useTime) {
                    if (this.state$.progress == 0) this.timedOut();
                }
                if (this.checkWinCondition()) this.puzzleSolved();
                break;
            case "gamewon":
                // Keep adding points until progress reached 0
                if (this.waitForCenterAnimation) break;
                if (this.state$.progress > 0) this.addProgressPoint();
                else {
                    this.platform.sendTimeleft(0);
                    this.levelCompleted();
                }
                break;
            case "prepareNext":
                break;
            case "ready":
                break;
            case "gameover":
                if (this.checkWinCondition()) {
                    this.setGameState("playing");
                    this.puzzleSolved();
                }
                break;
        }
        document.getElementById("remainingtime").innerHTML = this.state$.displayTime;
        // this.updateScore();
        this.canvas$.update();
        this.nextFrame();
    }
    nextFrame() {
        window.setTimeout(()=>{
            window.requestAnimationFrame(this.doEvents.bind(this));
        });
    }
    timedOut() {
        if (this.state$.gameState !== "playing") return;
        this.setGameState("gameover");
        if (this.config.timeupMessage) this.showPopup(this.config.timeupMessage, [
            {
                caption: this.config$.btnOkText,
                event: ()=>{
                    this.sendScore();
                    this.closePopup();
                }
            }
        ]);
        else setTimeout(()=>{
            this.sendScore();
        }, this.config$.gameOverTime);
    }
    sendScore() {
        if (!this.state$.resultsend) {
            console.log("GAMEOVER");
            this.state$.resultsend = true;
            this.platform.gameover(Math.round(this.state$.score));
        // Next game timeout
        // setTimeout(() => {
        //   this.prepareGame();
        // }, 2000);
        }
    }
    showPause() {
        if (this.state$.gameState !== "playing") return;
        this.pause();
        this.showPopup(this.config$.pauseText, [
            {
                caption: this.config$.btnOkText,
                event: ()=>{
                    this.resume();
                    this.playSound("btnClick");
                }
            }
        ]);
    }
    confirmStop() {
        this.pause();
        this.showPopup(this.config$.stopMessage, [
            {
                caption: this.config$.btnYesText,
                event: ()=>{
                    this.sendScore();
                    this.playSound("btnClick");
                }
            },
            {
                caption: this.config$.btnNoText,
                event: ()=>{
                    this.closePopup();
                    this.resume();
                    this.playSound("btnClick");
                }
            }
        ]);
    }
    puzzleSolved() {
        if (this.state$.gameState !== "playing") return;
        // Remove buttons
        document.getElementById("buttonBar").classList.remove("open");
        // Set state
        this.waitForCenterAnimation = true;
        this.setGameState("gamewon");
        setTimeout(()=>{
            this.waitForCenterAnimation = false;
        }, this.config.solvedCenterTime);
        // Move final layer to center
        this.layers$[0].setPosition({
            x: (this.sizes$.canvas.width - this.sizes$.puzzle.width) / 2 + this.config$.puzzleBoxPadding,
            y: this.config.verticalMargin + (this.sizes.canvas.height - this.config.verticalMargin * 2 - this.sizes.puzzle.height) / 2 + this.config$.puzzleBoxPadding
        }, true, this.config$.solvedCenterTime);
    }
    /**
   * Called when all points are added to the score and the use has seen the message for some time.
   */ levelCompleted() {
        this.setGameState("prepareNext");
        if (this.state$.activeLevel === this.levels$.length - 1) this.gameFinished();
        else this.levelFinished();
    }
    /**
   * @returns
   */ levelFinished() {
        this.setGameState("prepareNext");
        this.platform.pause();
        this.playSound("levelFinished");
        this.showPopup(this.config.solvedMessage, [
            {
                caption: this.config.btnOkText,
                event: ()=>{
                    this.closePopup();
                    this.nextLevel();
                    this.playSound("btnClick");
                }
            }
        ]);
    }
    gameFinished() {
        this.playSound("gameFinished");
        this.showPopup(this.config.finishedMessage, [
            {
                caption: this.config.btnOkText,
                event: ()=>{
                    this.sendScore();
                    this.playSound("btnClick");
                }
            }
        ]);
    // setTimeout(() => {
    //   this.sendScore();
    // }, this.config$.gameOverTime);
    }
    setGameState(newState) {
        this.state$.gameState = newState;
    }
    updateScore() {
        // this.ELMScoreContainer.innerHTML = Math.round(this.state$.score)
        //   .toString()
        //   .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.platform.sendScore(Math.round(this.state$.score));
    }
    /**
   * Updates the relative progress of the duration (% of time left)
   * @returns
   */ updateRemainingTime() {
        if (this.state$.gameState !== "playing") return;
        const remainingTime = (new Date().getTime() - this.state$.startTime.getTime()) / 1000;
        const timeInPercentage = 100 - remainingTime / this.state$.level.duration * 100;
        this.state$.progress = Math.max(0, timeInPercentage);
        this.state$.displayTime = this.formatTime((new Date().getTime() - this.state$.startTime.getTime()) / 1000);
    }
    // Show the preview of the puzzle. Can never be called from playing state
    preview() {
        this.start();
    // this.setGameState('preview');
    // Start the game after the preview timeout is reached
    }
    start() {
        // if (this.state$.gameState !== 'ready') {
        //   console.error('Start called in wrongstate');
        //   return;
        // }
        setTimeout(()=>{
            this.showPopup(this.config$.previewMessage, [
                {
                    caption: this.config$.btnOkText,
                    event: ()=>{
                        this.platform.resume();
                        this.platform.gamestarted();
                        this.state$.showBars = true;
                        document.getElementById("buttonBar").classList.add("open");
                        document.getElementById("buttonBar").classList.add("open2");
                        this.playSound("btnClick");
                        this.shuffleTiles();
                        document.getElementById("myProgress").style.visibility = "visible";
                        document.getElementById("myBar").style.width = "100%";
                        setTimeout(()=>{
                            // document.getElementById('buttonBar').classList.add('open');
                            // document.getElementById('buttonBar').classList.add('open2');
                            // Store starttime, and update state
                            this.state$.startTime = new Date();
                            this.setGameState("playing");
                        // this.setGameState('playing');
                        }, this.config$.shuffleTime);
                        this.closePopup();
                    }
                }
            ]);
        }, this.config.previewTime);
    // this.closePopup();
    // this.shuffleTiles();
    // Show bars when shuffle is done
    }
    initToolbar() {
        // const buttonBar = document.getElementById('buttonBar'); // gamestate is ready
        if (this.config$.showShuffle) {
            const buttonShuffle = document.getElementById("btnShuffle"); // gamestate is ready
            buttonShuffle.style.display = "flex";
            buttonShuffle.innerHTML = this.config$.btnShuffleText;
            (0, $22f5f922ddc3e706$export$9c04d8fd885bb013)(buttonShuffle, ()=>{
                if (this.state.gameState === "playing") {
                    this.playSound("btnClick");
                    this.shuffleTiles();
                }
            });
        }
        if (this.config$.showStop) {
            const buttonStop = document.getElementById("btnStop"); // gamestate is ready
            buttonStop.innerHTML = this.config$.btnStopText;
            buttonStop.style.display = "flex";
            (0, $22f5f922ddc3e706$export$9c04d8fd885bb013)(buttonStop, ()=>{
                if (this.state.gameState === "playing") {
                    this.playSound("btnClick");
                    this.confirmStop();
                }
            });
        }
        if (this.config$.showTimeBox === false) {
            const timeBox = document.getElementById("remainingtime");
            timeBox.style.visibility = "hidden";
        }
    }
    patchCss() {
        const css = this.style("#score-container", this.conditionalStyle("color", this.config$.scoreFontColor) + this.conditionalStyle("font-size", this.config$.scoreFontSize, "px") + this.conditionalStyle("font-family", this.config$.scoreFont) + this.conditionalStyle("padding-top", this.config$.scoreOffsetY, "px")) + this.style(".btn", this.conditionalStyle("font-family", this.config$.btnFont) + this.conditionalStyle("border-radius", this.config$.btnBorderRadius, "px")) + this.style(".btn", this.conditionalStyle("color", this.config$.btnFontColor)) + this.style(".btn", this.conditionalStyle("font-size", this.config$.btnFontSize, "px")) + this.style(".btn", this.conditionalStyle("background-color", this.config$.btnColor)) + this.style("#popupMessage", this.conditionalStyle("font-family", this.config$.popupFont) + this.conditionalStyle("font-size", this.config$.popupFontSize, "px") + this.conditionalStyle("border-radius", this.config$.popupBorderRadius, "px") + // this.conditionalStyle('opacity', this.config$.popupBackgroundOpacity) +
        this.conditionalStyle("background-color", this.config$.popupBackgroundColor) + this.conditionalStyle("color", this.config$.popupFontColor)) + this.style(".timebox", this.conditionalStyle("font-family", this.config$.timeBoxFont) + this.conditionalStyle("border-radius", this.config$.timeBoxBorderRadius, "px")) + this.style(".timebox", this.conditionalStyle("font-size", this.config$.timeBoxFontSize, "px") + this.conditionalStyle("color", this.config$.timeBoxFontColor) + this.conditionalStyle("background-color", this.config$.timeBoxColor)) + this.style(".modal", this.conditionalStyle("background-color", this.config$.overlayColor));
        const sheet = document.createElement("style");
        sheet.innerHTML = css;
        console.log(css);
        document.body.appendChild(sheet);
    }
    conditionalStyle(name, value, postfix = "") {
        if (!value) value = 0;
        return `
     ` + name + ": " + value + postfix + ";";
    }
    style(name, value) {
        return `
     ` + name + " { " + value + " } ";
    }
    backgroundImage(filename) {
        const path = this.config$.path;
        // const cache = this.$enableCreatorMode ? '?' + Date.now() : '';
        const cache = ""; //'?' + Date.now();
        return "url('" + path + "/" + filename + cache + "')";
    }
    formatTime(time) {
        // Hours, minutes and seconds
        const hrs = ~~(time / 3600);
        const mins = ~~(time % 3600 / 60);
        const secs = ~~time % 60;
        // Output like "1:01" or "4:03:59" or "123:03:59"
        let ret = "";
        if (hrs > 0) ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }
    playSound(soundKey, loop = false) {
        const config = this.config;
        if (config[soundKey + "Sound"]) this.platform.playSound(config.path + "/" + config[soundKey + "Sound"]);
    }
} // static debugData: Array<{ name: string, data: unknown }> = [];
 // public setDebugInfo(name: string, data: unknown) {
 //   Game.debugData = Game.debugData.filter(a => a.name !== name);
 //   Game.debugData.push({ name, data });
 //   document.getElementById('debugInfo').innerHTML =
 //     Game.debugData.map(d => {
 //       return '<div><pre>' + d.name + ':' + JSON.stringify(d.data, null, 2) + '</pre><div>';
 //     }).join('');
 // }


function $ad2bcec7a0192558$export$140d7860bc6d1e6e(...message) {
    console.log(...message);
}
document.addEventListener("DOMContentLoaded", ()=>{
    // eslint-disable-next-line no-new
    new (0, $ee901c93ece588f3$export$740547f5752a17b4)();
});


//# sourceMappingURL=index.825e4042.js.map
